import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { map } from "lodash";
import useSession from "Hooks/session.hook";
import { ParcelOrderList } from "Components/order-management/parcel-order-list";
import { Button } from "@life-line-lab/components-react";
import useAccessControlList from "Hooks/access-control.hook";
import { useOrderListingStates } from "Helpers/index";
import useCorporateType from "Hooks/corporate-type.hook";

const PendingConfirmationTab = ({
  baseColumns,
  handleRefreshData,
  handleModalAction,
}) => {
  const { roleTypes } = useSession();
  const { isCustomer } = useCorporateType();
  const [isViewOnly, setIsViewOnly] = useState<any>(true);
  const { t } = useTranslation();
  const { selectedRows } = useOrderListingStates();
  const permission = useAccessControlList({
    roleTypes: roleTypes,
    resource: "Order_Management",
  });

  const showUpdateOption = permission.rights.includes("UPDATE");

  const allColumns = baseColumns.concat([
    {
      title: t("label.issueType").toLocaleUpperCase(),
      dataIndex: ["orderStatusInfo"],
      width: 150,
      render: (orderStatusInfo: any) => {
        return (
          <span>
            {map(orderStatusInfo.issueType, (issue) => {
              return (
                <span>
                  {issue?.name || <span>&#11835;</span>}
                  <br />
                </span>
              );
            })}
          </span>
        );
      },
    },
    {
      title: t("label.type").toLocaleUpperCase(),
      dataIndex: ["parcels"],
      width: 80,
      render: (parcels: any) => {
        return (
          <span>
            {map(parcels, (parcel) => {
              return (
                <span>
                  {parcel?.name || <span>&#11835;</span>}
                  <br />
                </span>
              );
            })}
          </span>
        );
      },
    },
    {
      title: t("label.value").toLocaleUpperCase(),
      dataIndex: ["totalValueOfGoods"],
      width: 70,
    },
    {
      title: t("label.action").toLocaleUpperCase(),
      dataIndex: [],
      width: 150,
      render: (_: any, record: any) => {
        if (record.orderStatusInfo.orderStatus != "OPEN") {
          return (
            <div>
              {!isViewOnly && showUpdateOption ? (
                <div className="btn-actions-container">
                  <Button
                    type="success"
                    label={t("action.confirm")}
                    onClick={() => {
                      const allOrderIDs = record.childrenOrderIDs
                        ? [record._id, ...record.childrenOrderIDs]
                        : [record._id];
                      handleModalAction("CONFIRM", allOrderIDs);
                    }}
                    className="approve-btn"
                  />
                  <Button
                    type="danger"
                    label={t("action.cancel")}
                    onClick={() => {
                      const allOrderIDs = record.childrenOrderIDs
                        ? [record._id, ...record.childrenOrderIDs]
                        : [record._id];
                      handleModalAction(
                        "CANCEL",
                        allOrderIDs,
                        record._id,
                        record.senderID,
                      );
                    }}
                    className="flag-btn"
                  />
                </div>
              ) : (
                "-"
              )}
            </div>
          );
        }
      },
    },
  ]);

  useEffect(() => {
    if (
      roleTypes !== "COMPANY-SUPER_ADMIN" ||
      roleTypes !== "CUSTOMER-SUPER_ADMIN"
    ) {
      setIsViewOnly(false);
    }
  }, roleTypes);

  return (
    <ParcelOrderList
      columns={allColumns}
      additionalComponent={
        showUpdateOption ? (
          <div className="btn-actions-container">
            <Button
              label={t("action.massConfirm")}
              type="primary"
              size="large"
              isDisabled={selectedRows.length === 0}
              onClick={() => handleModalAction("MASSCONFIRM")}
            />
          </div>
        ) : (
          <></>
        )
      }
      isCheckBoxShown={true}
      filterItems={
        !isCustomer ? ["deliveryType", "customersList"] : ["deliveryType"]
      }
      radioButtonComponent={undefined}
      handleRefreshData={handleRefreshData}
    />
  );
};

export default PendingConfirmationTab;
